"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EFiscalYearEnds;
(function (EFiscalYearEnds) {
    EFiscalYearEnds["JUNE_END"] = "JUNE_END";
    EFiscalYearEnds["DECEMBER_END"] = "DECEMBER_END";
})(EFiscalYearEnds = exports.EFiscalYearEnds || (exports.EFiscalYearEnds = {}));
var EFacilityResidentSpectialBalanceActionTypes;
(function (EFacilityResidentSpectialBalanceActionTypes) {
    EFacilityResidentSpectialBalanceActionTypes["MARK_DO_NOT_BILL"] = "MARK_DO_NOT_BILL";
    EFacilityResidentSpectialBalanceActionTypes["SEND_OUT"] = "SEND_OUT";
    EFacilityResidentSpectialBalanceActionTypes["DO_NOT_GENERATE_STATEMENT"] = "DO_NOT_GENERATE_STATEMENT";
})(EFacilityResidentSpectialBalanceActionTypes = exports.EFacilityResidentSpectialBalanceActionTypes || (exports.EFacilityResidentSpectialBalanceActionTypes = {}));
var EFacilityStatementMode;
(function (EFacilityStatementMode) {
    EFacilityStatementMode["LINE_ITEM"] = "LINE_ITEM";
    EFacilityStatementMode["TRANSACTION_EFFECTIVE_DATE"] = "TRANSACTION_EFFECTIVE_DATE";
})(EFacilityStatementMode = exports.EFacilityStatementMode || (exports.EFacilityStatementMode = {}));
var EFacilityNcsDirectDepositAction;
(function (EFacilityNcsDirectDepositAction) {
    EFacilityNcsDirectDepositAction["INCLUDE_ON_STATEMENT"] = "INCLUDE_ON_STATEMENT";
    EFacilityNcsDirectDepositAction["DO_NOT_INCLUDE_ON_STATEMENT"] = "DO_NOT_INCLUDE_ON_STATEMENT";
})(EFacilityNcsDirectDepositAction = exports.EFacilityNcsDirectDepositAction || (exports.EFacilityNcsDirectDepositAction = {}));
var EFacilityNcsDirectDepositOptions;
(function (EFacilityNcsDirectDepositOptions) {
    EFacilityNcsDirectDepositOptions["START_DATE"] = "START_DATE";
    EFacilityNcsDirectDepositOptions["PREBILL"] = "PREBILL";
    EFacilityNcsDirectDepositOptions["PREBILL_1_MONTH"] = "PREBILL_1_MONTH";
    EFacilityNcsDirectDepositOptions["PREBILL_2_MONTH"] = "PREBILL_2_MONTH";
})(EFacilityNcsDirectDepositOptions = exports.EFacilityNcsDirectDepositOptions || (exports.EFacilityNcsDirectDepositOptions = {}));
var EFacilityPaymentAccountStatus;
(function (EFacilityPaymentAccountStatus) {
    EFacilityPaymentAccountStatus["PENDING"] = "PENDING";
    EFacilityPaymentAccountStatus["ACTIVE"] = "ACTIVE";
    EFacilityPaymentAccountStatus["ERROR"] = "ERROR";
})(EFacilityPaymentAccountStatus = exports.EFacilityPaymentAccountStatus || (exports.EFacilityPaymentAccountStatus = {}));
var EFacilityPaymentOrderBase;
(function (EFacilityPaymentOrderBase) {
    EFacilityPaymentOrderBase["PAYER_TYPE"] = "PAYER_TYPE";
    EFacilityPaymentOrderBase["CHARGE_DATE"] = "CHARGE_DATE";
    EFacilityPaymentOrderBase["BIGGEST_BALANCE"] = "BIGGEST_BALANCE";
})(EFacilityPaymentOrderBase = exports.EFacilityPaymentOrderBase || (exports.EFacilityPaymentOrderBase = {}));
var EFacilityPaymentOrder;
(function (EFacilityPaymentOrder) {
    EFacilityPaymentOrder["NEW_CHARGES"] = "NEW_CHARGES";
    EFacilityPaymentOrder["OLD_CHARGES"] = "OLD_CHARGES";
    EFacilityPaymentOrder["DEPEND_PAYER_TYPE"] = "DEPEND_PAYER_TYPE";
})(EFacilityPaymentOrder = exports.EFacilityPaymentOrder || (exports.EFacilityPaymentOrder = {}));
var EFacilityPayerTypePaymentOrder;
(function (EFacilityPayerTypePaymentOrder) {
    EFacilityPayerTypePaymentOrder["NEWEST"] = "NEWEST";
    EFacilityPayerTypePaymentOrder["OLDEST"] = "OLDEST";
})(EFacilityPayerTypePaymentOrder = exports.EFacilityPayerTypePaymentOrder || (exports.EFacilityPayerTypePaymentOrder = {}));
var EFacilityPayerTypePaymentResidentType;
(function (EFacilityPayerTypePaymentResidentType) {
    EFacilityPayerTypePaymentResidentType["CURRENT"] = "CURRENT";
    EFacilityPayerTypePaymentResidentType["DISCHARGED"] = "DISCHARGED";
    EFacilityPayerTypePaymentResidentType["BOTH"] = "BOTH";
})(EFacilityPayerTypePaymentResidentType = exports.EFacilityPayerTypePaymentResidentType || (exports.EFacilityPayerTypePaymentResidentType = {}));
var EFacilityUpdateStatus;
(function (EFacilityUpdateStatus) {
    EFacilityUpdateStatus["PENDING"] = "PENDING";
    EFacilityUpdateStatus["SUCCESS"] = "SUCCESS";
    EFacilityUpdateStatus["ERROR"] = "ERROR";
    EFacilityUpdateStatus["IDLE"] = "IDLE";
})(EFacilityUpdateStatus = exports.EFacilityUpdateStatus || (exports.EFacilityUpdateStatus = {}));
;
var EFacilityBlockableFeatures;
(function (EFacilityBlockableFeatures) {
    EFacilityBlockableFeatures["MailAndGenStatements"] = "MailAndGenStatements";
})(EFacilityBlockableFeatures = exports.EFacilityBlockableFeatures || (exports.EFacilityBlockableFeatures = {}));
